import { useMutation, useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalPostRequest } from "@api/functions/changeRequests";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { handleNetworkError } from "@repo/ui/libs";

// Get global auth user hook
export const useGetAuthUserService = () => {
  const authService = useQuery({
    queryKey: CACHE_KEYS.AUTH_USER,
    queryFn: () => handleGlobalGetRequestQuery({ url: URLS.AUTH_USER }),
  });

  return { authService };
};

// Auth mutation hook for broker
export const useAuthServiceMutations = () => {
  const loginMutation = useMutation({
    mutationFn: (data: any) =>
      handleGlobalPostRequest({ url: URLS.LOGIN, data }),
  });

  const logoutMutation = useMutation({
    mutationFn: () => handleGlobalPostRequest({ url: URLS.LOGOUT }),
  });

  return { loginMutation, logoutMutation };
};
export const useGetPartnerTokenMutation = () => {
  const partnerTokenGeneration = useMutation({
    mutationFn: (data: { client_id: string; client_secret: string }) => {
      return handleGlobalPostRequest({
        url: URLS?.GENERATE_PARTNER_TOKEN,
        data,
      });
    },
    onError: handleNetworkError,
  });
  return { partnerTokenGeneration };
};
// Auth mutation hook for partner=
export const usePartnerAuthServiceMutations = () => {
  const whichPartner = import.meta.env.DEV
    ? "rupenetsol"
    : location.host?.split(".")?.[0];
  const loginMutation = useMutation({
    mutationFn: (data: any) =>
      handleGlobalPostRequest({ url: `/partners/${whichPartner}/login`, data }),
  });

  const logoutMutation = useMutation({
    mutationFn: () => handleGlobalPostRequest({ url: URLS.LOGOUT }),
  });

  return { loginMutation, logoutMutation };
};
